import { render, staticRenderFns } from "./inviteWarehousing.vue?vue&type=template&id=2caa5b68&scoped=true&"
import script from "./inviteWarehousing.vue?vue&type=script&lang=js&"
export * from "./inviteWarehousing.vue?vue&type=script&lang=js&"
import style0 from "./inviteWarehousing.vue?vue&type=style&index=0&id=2caa5b68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa5b68",
  null
  
)

export default component.exports